import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_RESEARCH_POD_REPORT_PAGE: IInventoryPage = {
	'route': '/research/research/pod-report',
	'title': 'POD Report',
	'uiReference': [
		'Print-on-Demand Report',
		"This Week's POD Report",
		'Download Now',
		"Last Week's POD Report"
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/research-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/pod-report/pod-report.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/research/pod-report/pod-report.component.html'
	],
	'aliases': []
};
